export default ($v, modelValue) => {
    $v.value[modelValue].$touch();
    return !$v.value[modelValue].$error;
};
